module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex flex-state-buttons p-executive-dashboard__reserves"
  }, [_c('h2', {
    staticClass: "u-margin-top-10 u-r-no-margin"
  }, [_vm._v("\n            Reserves \n            "), (_vm.diseaseOrAccident || _vm.claimType === 'personal_injury') ? _c('span', [_vm._v("\n                " + _vm._s(_vm.diseaseOrAccident === 'disease' ? 'by Disease' : 'by Accident') + "\n            ")]) : _c('span', [_vm._v("\n                by Claim Type\n            ")])]), _vm._v(" "), _c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'average'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('average')
      }
    }
  }, [_vm._v("\n                Average\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'total'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('total')
      }
    }
  }, [_vm._v("\n                Total\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'trend-average'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('trend-average')
      }
    }
  }, [_vm._v("\n                Trends: Average Reserve\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'trend-total'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('trend-total')
      }
    }
  }, [_vm._v("\n                Trends: Total Reserve\n            ")])])], 1), _vm._v(" "), ((_vm.chartType === 'average' || _vm.chartType === 'total') && _vm.show) ? _c('summary-charts', {
    attrs: {
      "type": "value",
      "run-type": _vm.chartType === 'average' ? 'averageReserve' : 'totalReserve',
      "chart-data": _vm.chartType === 'average' ? _vm.averageReservesChartData : _vm.totalReservesChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend-average' && _vm.show) ? _c('trends-chart', {
    attrs: {
      "type": "value",
      "showing": "average",
      "chart-data": _vm.trendsInAverageReservesChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend-total' && _vm.show) ? _c('trends-chart', {
    attrs: {
      "type": "value",
      "showing": "total",
      "chart-data": _vm.trendsInTotalReservesChartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2bf7240!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/ReserveSection.vue
// module id = 1823
// module chunks = 0